import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    contact: "",
    uuvid6: "",
  });

  const [loading, setLoading] = useState(false); // Loading state
  const [errors, setErrors] = useState({}); // Error state for validation

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" })); // Clear errors for this field
  };

  const validateFields = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.contact.trim()) newErrors.contact = "Contact is required.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateFields();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true); // Set loading to true

    const userUuid = uuidv4();

    const userData = {
      ...formData,
      uuvid6: userUuid,
    };

    // Fetch the base URL from the environment variable
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiUrl = `${apiBaseUrl}/initialstore`; // Append the endpoint

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        throw new Error(`API request failed: ${response.statusText}`);
      }

      const responseData = await response.json();

      localStorage.setItem("userData", JSON.stringify(userData));
      navigate("/user/home");
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while saving data. Please try again.");
    } finally {
      setLoading(false); // Reset loading to false
    }
  };

  return (
    <main className="min-h-screen w-full relative">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat -z-10"
        style={{
          backgroundImage: "url(../assets/images/user-login-bg.png)",
        }}
      />
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl md:text-3xl font-bold text-white my-8 heading-text-user">
          Media Sentinel
        </h1>

        <form
          className="flex w-[35%] flex-col gap-8 login-form"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Name"
              className={`px-4 py-2 rounded-md text-white placeholder-white focus:outline-none ${
                errors.name ? "border-red-500" : ""
              }`}
            />
            {errors.name && (
              <span className="text-red-500 text-sm mt-1">{errors.name}</span>
            )}
          </div>
          <div className="flex flex-col">
            <input
              type="text"
              name="contact"
              value={formData.contact}
              onChange={handleInputChange}
              placeholder="Email/Phone no."
              className={`px-4 py-2 rounded-md text-white placeholder-white focus:outline-none ${
                errors.contact ? "border-red-500" : ""
              }`}
            />
            {errors.contact && (
              <span className="text-red-500 text-sm mt-1">
                {errors.contact}
              </span>
            )}
          </div>
          <button
            type="submit"
            disabled={loading} // Disable button while loading
            className={`w-[50%] mt-3 mx-auto rounded-md bg-gray-800 text-white font-regular transition-all user-button ${
              loading ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  ></path>
                </svg>
                Loading...
              </span>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
    </main>
  );
}
